/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Drawer, DrawerProps } from 'antd';
import classNames from 'classnames';
import { CloseIcon } from 'assets/icons';
import './Drawer.scss';

const DrawerFrame = ({ className, ...props }: DrawerProps) => (
  <Drawer
    placement="right"
    destroyOnClose
    closeIcon={<CloseIcon />}
    {...props}
    className={classNames('drawer', className)}
  />
);

export default DrawerFrame;
